import { createContext } from 'react';
export var topModelNameTransformContext = createContext(function (str) { return str; });
